import { RecordPlugin, RecordPluginDescriptor, useDefaultRecordPlugin } from '#record/plugin'
import { usePriorTrxAuthzJsonSerializer } from '#trxauth.prior/jsonserializer'
import { newPriorTrxAuthzSlot, PriorTrxAuthPatch } from '#trxauth.prior/model'
import { PriorTrxAuthzOverview } from '#trxauth.prior/overview'
import { usePriorTrxAuthzParser } from '#trxauth.prior/parser'
import { PriorTrxAuthzPatchCard } from '#trxauth.prior/patch'
import { usePriorTrxAuthzValidation } from '#trxauth.prior/validator'
import { useT } from 'apprise-frontend-core/intl/language'
import { usePriorTrxAuthzColumns } from './columns'
import { patchedTypes, PriorTrxAuthzIcon } from './constants'


export const usePriorTrxAuthzPluginDescriptor = (): RecordPluginDescriptor => {

    const t = useT()

    const defaults = useDefaultRecordPlugin()

    return {

        ...defaults

        ,

        Icon: PriorTrxAuthzIcon

        ,

        name: t('priortrxauthz.type')

        ,

        submission_type: t('priortrxauthz.sub_type')

        ,

        singular: t('priortrxauthz.singular')

        ,

        plural: t('priortrxauthz.plural')

        ,

        patchedTypes


    }

}

export const usePriorTrxAuthzPlugin = () => {

    const self: RecordPlugin<PriorTrxAuthPatch> = {

        ...useDefaultRecordPlugin(),

        ...usePriorTrxAuthzPluginDescriptor(),

        patchColumns: usePriorTrxAuthzColumns,

         parse: usePriorTrxAuthzParser,

        jsonserialize: usePriorTrxAuthzJsonSerializer,

        Patch: PriorTrxAuthzPatchCard,

        validate: usePriorTrxAuthzValidation,

        Overview: PriorTrxAuthzOverview,

        newSlot: newPriorTrxAuthzSlot

    }

    return self
}
